module.exports = __webpack_public_path__ + "media/icons/czesci@3x-980a3e6e.svg";